"use strict";

//scroll magicのコントローラーの定義
var controller = new ScrollMagic.Controller();

function bgParallax(controller, ele, duration) {
  var eles = document.querySelectorAll(ele);
  eles.forEach(function (ele) {
    var target = ele.querySelector('img');
    var tween = TweenMax.fromTo(target, 0.8, {
      y: "-".concat(duration),
      ease: Linear.easeNone
    }, {
      y: "".concat(duration),
      ease: Linear.easeNone
    });
    new ScrollMagic.Scene({
      triggerElement: ele,
      triggerHook: "onEnter",
      duration: "200%"
    }).setTween(tween) // .addIndicators()
    .addTo(controller);
  });
}

bgParallax(controller, '.js-bgParallax', '20%');
/**
 * scrollMagicを通じて、スクロール量に応じたマーキーアニメーションを実行
 * @param {*} controller 
 * @param {*} ele 
 * @param {*} targetEle 
 */

function scrollMarqueeAnim(controller, ele, targetEle, duration) {
  var tl = new TimelineMax();
  tl.fromTo(ele, {
    xPercent: 0
  }, {
    xPercent: -200,
    ease: Linear.easeNone,
    scrollTrigger: {
      trigger: ele,
      start: 'center center',
      //アニメーションが始まる位置
      end: 'bottom center',
      //アニメーションが終わる位置
      scrub: true,
      //スクロール量に合わせてアニメーション
      toggleActions: "play complete reverse reset" //逆再生あり設定

    }
  });
  new ScrollMagic.Scene({
    triggerElement: targetEle,
    duration: duration,
    triggerHook: 'onCenter'
  }).setTween(tl) // .addIndicators()
  .addTo(controller);
}
/**
 * 画面に入ったらポップなバウンスアニメーションを開始する
 */


var section = document.querySelectorAll('.js-popBounce');

if (section.length) {
  var _loop = function _loop(i) {
    // console.log(section[i])
    var scene = new ScrollMagic.Scene({
      triggerElement: section[i]
    });
    scene.on("enter", function () {
      var delay = Number(section[i].dataset.popbouncedDelay); // console.log(delay)

      setTimeout(function () {
        section[i].classList.add('is-animated');
      }, delay);
    }).addTo(controller);
  };

  for (var i = 0; i < section.length; i++) {
    _loop(i);
  }
}
/**
 * MVのテキストラインを複製する
 */


function setCloneTextLine() {
  var wrapper = document.querySelector('.js-infiniteLoopSlider');
  var target = document.querySelector('.js-infiniteLoopSlider__base');
  var text = wrapper.innerText;
  var textWidth = target.clientWidth;
  var textHeight = target.clientHeight;
  var style = getComputedStyle(target); // console.log(style)
  // console.log(`text:${text}`,`length:${text.length}`,`textWidth:${textWidth}`,`fontSize:${style.fontSize}`)

  var attr = {
    // width: Number(style.width.replace(/px/,"")),
    width: Number(textWidth),
    // height: Number(style.height.replace(/px/,"")),
    height: Number(textHeight),
    fontSize: style.fontSize,
    fontFamily: style.fontFamily,
    fontWeight: style.fontWeight,
    letterSpacing: style.letterSpacing,
    stroke: "#000",
    fill: "transparent",
    fillOpacity: "0"
  };
  wrapper.insertBefore(createSVG(text, attr), target);
  wrapper.appendChild(createSVG(text, attr));
}
/**
 * 指定した文字列のsvgデータを作成する
 * @param {*} str 
 * @param {*} strInfo 
 * @returns 
 */


function createSVG(str, strInfo) {
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); // svg.setAttribute('id',str)

  svg.setAttribute('viewbox', "0 0 ".concat(strInfo.width, " ").concat(strInfo.height)); // svg.setAttribute('width','100%')
  // svg.setAttribute('style',`min-width:${strInfo.width}px;`)

  svg.setAttribute('preserveAspectRatio', 'none'); // console.log('str',str)

  var text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  text.innerHTML = str;
  text.setAttribute('x', 0);
  text.setAttribute('y', '50%');
  text.setAttribute('fill', strInfo.fill);
  text.setAttribute('fill-opacity', strInfo.fillOpacity);
  text.setAttribute('stroke', strInfo.stroke);
  text.setAttribute('font-size', strInfo.fontSize);
  text.setAttribute('font-family', strInfo.fontFamily);
  text.setAttribute('font-weight', strInfo.fontWeight);
  text.setAttribute('letter-spacing', strInfo.letterSpacing);
  text.setAttribute('dominant-baseline', 'central'); // console.log(text)

  svg.appendChild(text); // console.log(text.style.width)
  // console.log(svg)

  return svg;
}

function myPromise() {
  return new Promise(function (resolve, reject) {
    setCloneTextLine(); // console.log('step1')

    resolve('OK');
  });
}

myPromise().then(function (data) {
  return new Promise(function (resolve, reject) {
    // console.log(data)
    var body = document.querySelector('body');
    var ww = body.clientWidth; // console.log(`ww:${ww}`)

    if (ww > 768) {
      scrollMarqueeAnim(controller, '.js-infiniteLoopSlider', '.p-mv', '175%');
    } else {
      scrollMarqueeAnim(controller, '.js-infiniteLoopSlider', '.p-mv', '100%');
    }

    resolve();
  });
});
/**
 * MVのスライド
 */

var MVSwiper = new Splide('.js-mvSplider', {
  mediaQuery: 'min',
  type: 'fade',
  arrows: false,
  rewind: true,
  autoplay: true,
  interval: 3000,
  speed: 1500,
  pagination: false
});
MVSwiper.mount();
/**
 * community boardのギャラリースライダーの設定
 */

var gallerySwiper = new Splide('.js-communitySwiper', {
  mediaQuery: 'min',
  fixedWidth: '24rem',
  gap: 20,
  type: 'loop',
  arrows: false,
  drag: 'free',
  flickPower: 300,
  pagination: false,
  autoScroll: {
    speed: 0.5 //   pauseOnHover: false,
    //   pauseOnFocus: false,

  },
  breakpoints: {
    1025: {
      gap: 60,
      fixedWidth: '36rem'
    }
  }
});
gallerySwiper.mount(window.splide.Extensions);